import React from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { getMediaKitArticleContentPath } from 'site-modules/editorial/utils/content-path';
import { getMediaKitArticleBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { ResearchEntry } from 'site-modules/editorial/components/media-kit/research-entry/research-entry';

function MediaKitArticleUI({
  content = null,
  splat = null,
  type = null,
  articleId = null,
  isAppExtensionPage = false,
}) {
  if (!content) {
    return null;
  }

  const { title } = content;
  const mainEntries = content.child('main').children();
  const rightRailEntries = content.child('right-rail').children();

  return (
    <Container tag="main" id="main-content" tabIndex={-1} className="media-kit-article pb-2">
      {!isAppExtensionPage && (
        <Breadcrumbs className="px-0 mb-1_5" data={getMediaKitArticleBreadcrumbs({ splat, type, articleId, title })} />
      )}
      <h1 className="heading-2 mb-1_5">{title}</h1>
      <Row>
        <Col xs={12} lg={8} className="mb-1_5 mb-lg-0">
          {/* main */}
          {mainEntries.map((entry, index) => {
            const key = `main-${entry.id}-${index}`;

            return <ResearchEntry key={key} entry={entry} />;
          })}
        </Col>
        <Col xs={12} lg={4} className="mb-1_5 mb-lg-0">
          {/* right-rail */}
          {rightRailEntries.map((entry, index) => {
            const key = `right-rail-${entry.id}-${index}`;

            return <ResearchEntry key={key} entry={entry} />;
          })}
        </Col>
      </Row>
    </Container>
  );
}

MediaKitArticleUI.propTypes = {
  articleId: PropTypes.string,
  splat: PropTypes.string,
  type: PropTypes.string,
  content: CmsEntities.Content,
  isAppExtensionPage: PropTypes.bool,
};

export const MediaKitArticle = connectToModel(MediaKitArticleUI, {
  content: bindToContent(({ splat, type, articleId }) => getMediaKitArticleContentPath(splat, type, articleId)),
});
